<template>
  <div class="container-fluid">
    <page-title
      :title="this.$t('stream_profiles.title')"
      :hasModal="true"
      :modalId="'#modalForm'"
      @onButtonClick="setFormCreate()"
    ></page-title>

    <!-- DATATABLE PROFILE-->
    <table class="table mt-2 h-100" id="commentsTable">
      <thead>
        <tr>
          <th scope="col" class="text-center align-middle">
            {{ $t('stream_profiles.name') }}
          </th>
          <th scope="col" class="text-center align-middle">
            {{ $t('stream_profiles.display') }}
          </th>
          <th scope="col" class="text-center align-middle">
            {{ $t('stream_profiles.query') }}
          </th>
          <th scope="col" class="text-center align-middle">
            {{ $t('stream_profiles.actions') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(profile, index) in userStreamProfiles" :key="index">
          <td>{{ profile.name }}</td>
          <td class="text-center">
            {{ displayConfigInTable(profile.display_config) }}
          </td>
          <td class="text-center" v-if="profile.query_type === 'BOOKMARK'">
            BookmarkList: {{ profile.bookmarklist_id }}
          </td>
          <td class="text-center" v-if="profile.query_type === 'QUERY'">
            {{ displayConfigInTable(profile.query_config) }}
          </td>
          <td class="text-center">
            <button
              class="btn btn-danger btn-block"
              @click="profileToDelete = profile"
              data-toggle="modal"
              data-target="#modalDelete"
            >
              {{ $t('delete') }}
            </button>
            <button
              class="btn btn-warning btn-block"
              data-toggle="modal"
              data-target="#modalForm"
              @click="setFormUpdate(profile.id)"
            >
              {{ $t('stream_profiles.update') }}
            </button>
            <button
              class="btn btn-light btn-block"
              data-toggle="modal"
              data-target="#modalExport"
              @click="setExportCode(profile.export_code)"
            >
              {{ $t('stream_profiles.export') }}
            </button>
            <button class="btn btn-outline-success btn-block" @click="goToCommentStream(profile)">
              {{ $t('stream_profiles.launch') }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- MODAL delete -->
    <div class="modal fade" id="modalDelete" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('stream_profiles.delete') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-dark">
              {{ $t('stream_profiles.delete_confirmation') }}
              <span class="font-weight-bold">{{ profileToDelete.name }}</span> ?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="deleteProfile(profileToDelete.id)"
            >
              {{ $t('stream_profiles.submit') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL export -->
    <div class="modal fade" id="modalExport" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('stream_profiles.export') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form v-on:submit.prevent class="form">
              <h5 class="text-dark">{{ $t('stream_profiles.export_code') }}</h5>
              <div class="form-group">
                <input
                  v-model="exports.exportCode"
                  class="form-control"
                  placeholder="Export code here:"
                  readonly
                />
              </div>
              <h5 class="text-dark">{{ $t('stream_profiles.iframe') }}</h5>
              <div class="form-group">
                <input
                  v-model="exports.iFrameTag"
                  class="form-control"
                  placeholder="Export code here:"
                  readonly
                />
              </div>

              <h5 class="text-dark">{{ $t('stream_profiles.dimensions') }}</h5>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input
                      v-model="exports.areDimensionsEnabled"
                      @click="exportDimensionsChecked()"
                      type="checkbox"
                      aria-label="Checkbox for following text input"
                    />
                  </div>
                </div>
                <input
                  v-model="exports.width"
                  type="number"
                  class="form-control"
                  aria-label="Width input"
                />
                <input
                  v-model="exports.height"
                  type="number"
                  class="form-control"
                  aria-label="Height input"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL FORM -->
    <div
      class="modal fade"
      id="modalForm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ $t('stream_profiles.create') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form v-on:submit.prevent class="form" id="form-create">
            <div class="modal-body">
              <div class="form-create">
                <h2>{{ $t('stream_profiles.name') }}</h2>
                <div class="form-group">
                  <input v-model="form.name" class="form-control" required />
                </div>
                <hr />
                <h2>{{ $t('stream_profiles.query_type_choice') }}</h2>
                <label class="radio-inline">
                  <input type="radio" checked value="QUERY" v-model="form.queryType" required />
                  {{ $t('stream_profiles.filter_selection') }}
                </label>
                <label class="radio-inline">
                  <input type="radio" checked value="BOOKMARK" v-model="form.queryType" required />
                  {{ $t('stream_profiles.bookmark_selection') }}
                </label>
                <div class="query" v-if="form.queryType === 'QUERY'">
                  <div class="form-group">
                    <label for="form-fadeIn">{{ $t('stream_profiles.sites') }}</label>
                    <vue-tags-input
                      class="tags-input"
                      v-model="temp.site"
                      :tags="form.query.sites"
                      :autocomplete-items="autoCreateSite"
                      placeholder="Ajouter un site"
                      :add-only-from-autocomplete="true"
                      @before-adding-tag="checkTagSite"
                      @tags-changed="newTags => (this.form.query.sites = newTags)"
                    />
                  </div>
                  <div class="form-group">
                    <label for="form-fadeIn">{{ $t('stream_profiles.languages') }}</label>
                    <vue-tags-input
                      class="tags-input"
                      v-model="temp.language"
                      :tags="form.query.languages"
                      :autocomplete-items="autoCreateLanguage"
                      placeholder="Ajouter une langue"
                      :add-only-from-autocomplete="true"
                      @tags-changed="newTags => (this.form.query.languages = newTags)"
                    />
                  </div>
                  <div class="form-group">
                    <label for="form-fadeIn">{{ $t('stream_profiles.histopad_rating') }}</label>
                    <vue-tags-input
                      class="tags-input"
                      v-model="temp.histopadRating"
                      :tags="form.query.histopadRating"
                      placeholder="Ajouter une note"
                      :autocomplete-items="autoCreateHistopadRating"
                      :add-only-from-autocomplete="true"
                      @tags-changed="newTags => (this.form.query.histopadRating = newTags)"
                    />
                  </div>
                  <div class="form-group">
                    <label for="form-fadeIn">{{ $t('stream_profiles.visit_rating') }}</label>
                    <vue-tags-input
                      class="tags-input"
                      v-model="temp.visitRating"
                      :tags="form.query.visitRating"
                      placeholder="Ajouter une note"
                      :autocomplete-items="autoCreateVisitRating"
                      :add-only-from-autocomplete="true"
                      @tags-changed="newTags => (this.form.query.visitRating = newTags)"
                    />
                  </div>
                  <div class="form-group">
                    <label for="form-fadeIn">{{ $t('stream_profiles.limit') }}</label>
                    <input
                      class="form-control"
                      type="number"
                      max="1000"
                      v-model="form.query.limit"
                      required
                    />
                  </div>
                  <div class="input-group more-padding">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{
                        $t('stream_profiles.score_min_max')
                      }}</span>
                    </div>
                    <input
                      v-model="form.query.scoreMin"
                      type="number"
                      class="form-control"
                      required
                    />
                    <input
                      v-model="form.query.scoreMax"
                      type="number"
                      class="form-control"
                      required
                    />
                  </div>
                </div>

                <!-- bookmark -->
                <div class="bookmark" v-if="form.queryType === 'BOOKMARK'">
                  <div class="form-group">
                    <select
                      class="form-control"
                      id="displayList"
                      v-model="form.bookmarkId"
                      required
                    >
                      <option :value="list.id" v-for="list in userBookmarkLists" :key="list.id">
                        {{ list.title }}
                      </option>
                    </select>
                  </div>
                </div>

                <hr />
                <h2>{{ $t('stream_profiles.fade_comments') }}</h2>
                <div class="form-group">
                  <label for="form-fadeIn">{{ $t('stream_profiles.fade_in') }}</label>
                  <input
                    v-model="form.display.fadeIn"
                    type="range"
                    class="custom-range"
                    step="250"
                    min="0"
                    max="10000"
                    id="form-fadeIn"
                  />
                  <small class="form-text text-muted"
                    >{{ form.display.fadeIn * 0.001 }} {{ $t('stream_profiles.seconds') }}</small
                  >
                </div>

                <div class="form-group">
                  <label for="form-fadeIn">{{ $t('stream_profiles.fade_out') }}</label>
                  <input
                    v-model="form.display.fadeOut"
                    type="range"
                    class="custom-range"
                    step="250"
                    min="0"
                    max="10000"
                    id="form-fadeIn"
                  />
                  <small class="form-text text-muted"
                    >{{ form.display.fadeOut * 0.001 }} {{ $t('stream_profiles.seconds') }}</small
                  >
                </div>
                <div class="form-group">
                  <label for="form-fadeIn">{{ $t('stream_profiles.display_duration') }}</label>
                  <input
                    v-model="form.display.displayDuration"
                    type="range"
                    class="custom-range"
                    step="1000"
                    min="0"
                    max="50000"
                    id="form-fadeIn"
                  />
                  <small class="form-text text-muted"
                    >{{ form.display.displayDuration * 0.001 }}
                    {{ $t('stream_profiles.seconds') }}</small
                  >
                </div>
                <hr />
                <h2>{{ $t('stream_profiles.distances') }}</h2>
                <div class="form-group">
                  <label for="form-fadeIn">{{ $t('stream_profiles.min_edge') }}</label>
                  <input
                    v-model="form.display.minEdge"
                    type="range"
                    class="custom-range"
                    step="0.01"
                    min="0"
                    max="0.25"
                    id="form-fadeIn"
                  />
                  <small class="form-text text-muted"
                    >{{ Math.floor(form.display.minEdge * 100) }}
                    {{ $t('stream_profiles.min_tip') }}</small
                  >
                </div>
                <div class="form-group">
                  <label for="form-fadeIn">{{ $t('stream_profiles.min_comments') }}</label>
                  <input
                    v-model="form.display.minComment"
                    type="range"
                    class="custom-range"
                    step="0.01"
                    min="0"
                    max="0.25"
                    id="form-fadeIn"
                  />
                  <small class="form-text text-muted"
                    >{{ Math.floor(form.display.minComment * 100) }}
                    {{ $t('stream_profiles.min_tip') }}</small
                  >
                </div>
                <hr />
                <h2>{{ $t('stream_profiles.score') }}</h2>
                <div class="form-group">
                  <label for="form-fadeIn">{{ $t('stream_profiles.score_size_ratio') }}</label>
                  <input
                    v-model="form.display.scoreSizeRatio"
                    type="range"
                    class="custom-range"
                    step="0.01"
                    min="0"
                    max="0.6"
                    id="form-fadeIn"
                  />
                  <small class="form-text text-muted"
                    >{{ Math.floor(form.display.scoreSizeRatio * 100) }}
                    {{ $t('stream_profiles.score_size_ratio_tip') }}</small
                  >
                </div>
                <hr />
                <h2>{{ $t('stream_profiles.rotation') }}</h2>
                <div class="form-group">
                  <label for="form-fadeIn">{{ $t('stream_profiles.rotation_rate') }}</label>
                  <input
                    v-model="form.display.rotationRate"
                    type="range"
                    class="custom-range"
                    step="500"
                    min="0"
                    max="15000"
                    id="form-fadeIn"
                  />
                  <small class="form-text text-muted"
                    >{{ form.display.rotationRate * 0.001 }}
                    {{ $t('stream_profiles.seconds') }}</small
                  >
                </div>
                <div class="form-check">
                  <input
                    v-model="form.display.randomizeInitialDirection"
                    type="checkbox"
                    class="form-check-input"
                    id="form-randomizeInitialDirection"
                  />
                  <label for="form-randomizeInitialDirection">{{
                    $t('stream_profiles.randomize_initial_direction')
                  }}</label>
                </div>
                <div class="form-group">
                  <label for="form-activeCommentsOrder">{{
                    $t('stream_profiles.active_comments_order')
                  }}</label>
                  <select
                    v-model="form.display.activeCommentsOrder"
                    class="form-control"
                    id="form-activeCommentsOrder"
                  >
                    <option value="SHUFFLE">
                      {{ $t('stream_profiles.form_active_comments_order.random') }}
                    </option>
                    <option value="TIMEASC">
                      {{ $t('stream_profiles.form_active_comments_order.timeasc') }}
                    </option>
                    <option value="TIMEDESC">
                      {{ $t('stream_profiles.form_active_comments_order.timedesc') }}
                    </option>
                  </select>
                </div>
                <hr />
                <h2>{{ $t('stream_profiles.miscellaneous') }}</h2>
                <div class="form-check">
                  <input
                    v-model="form.display.activeParticules"
                    type="checkbox"
                    class="form-check-input"
                    value="true"
                    id="form-activeParticules"
                  />
                  <label class="form-check-label" for="form-activeParticules">{{
                    $t('stream_profiles.active_particules')
                  }}</label>
                </div>
                <div class="form-check">
                  <input
                    v-model="form.display.displayTitle"
                    type="checkbox"
                    class="form-check-input"
                    id="create-display-title"
                  />
                  <label for="create-display-title">{{
                    $t('stream_profiles.display_title')
                  }}</label>
                </div>
                <hr />
                <h2>{{ $t('stream_profiles.colors') }}</h2>
                <div class="form-group">
                  <label for="form-backgroundColor">{{
                    $t('stream_profiles.background_color')
                  }}</label>
                  <input
                    v-model="form.display.backgroundColor"
                    type="color"
                    class="form-control"
                    id="form-backgroundColor"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div class="form-group">
                  <label for="form-fontColor">{{ $t('stream_profiles.font_color') }}</label>
                  <input
                    v-model="form.display.fontColor"
                    type="color"
                    class="form-control"
                    id="form-fontColor"
                  />
                </div>
                <div class="form-group">
                  <label for="form-fontColor">{{ $t('stream_profiles.secondary_color') }}</label>
                  <input
                    v-model="form.display.secondaryColor"
                    type="color"
                    class="form-control"
                    id="form-secondaryColor"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                id="close-modal-create"
              >
                {{ $t('cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                v-on:click="submitForm"
                id="submit-displayConfig"
              >
                {{ $t('stream_profiles.submit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { utilsMixin } from '../utils/mixins'
import VueTagsInput from '@johmun/vue-tags-input'
import defaultFormValues from '../assets/default-stream-profile-form'

export default {
  name: 'StreamProfile',
  dependencies: ['dataService'],
  mixins: [utilsMixin],
  data() {
    return {
      startDate:
        this.$route.params.start != undefined
          ? new Date(this.$route.params.start)
          : moment().subtract(1, 'month'),
      endDate:
        this.$route.params.end != undefined
          ? new Date(this.$route.params.end)
          : moment(new Date(), 'YYYY-MM-DD'),
      state: 'INIT',
      stateTitle: '',
      userStreamProfiles: [],
      updateProfileId: '',
      exports: {
        exportCode: '',
        iFrameTag: '',
        width: 1280,
        height: 720,
        areDimensionsEnabled: false,
      },
      userBookmarkLists: [],
      profileToDelete: {},
      form: {
        display: {
          fadeIn: '',
          fadeOut: '',
          displayDuration: '',
          minEdge: '',
          minComment: '',
          scoreSizeRatio: '',
          rotationRate: '',
          randomizeInitialDirection: '',
          activeCommentsOrder: '',
          activeParticules: '',
          displayTitle: '',
          backgroundColor: '',
          fontColor: '',
          secondaryColor: '',
        },
        query: {
          sites: [],
          languages: [],
          scoreMin: '',
          scoreMax: '',
          limit: '',
          histopadRating: [],
          visitRating: [],
        },
        bookmarkId: null,
        queryType: '',
        name: '',
      },
      temp: {
        site: '',
        language: '',
        histopadRating: '',
        visitRating: '',
      },
      rating: [
        { text: '1', style: 'background-color: #DB5F5F', id: '1' },
        { text: '2', style: 'background-color: #DB5F5F', id: '2' },
        { text: '3', style: 'background-color: orange', id: '3' },
        { text: '4', style: 'background-color: orange', id: '4' },
        { text: '5', style: 'background-color: #9AD67C', id: '5' },
      ],
      tagsInput: {
        sites: {
          validation: [
            {
              classes: '',
            },
          ],
        },
      },
    }
  },
  components: {
    'page-title': () => import('./utils/PageTitle'),
    VueTagsInput,
  },
  mounted() {
    this.getUserStreamProfiles()
    this.fetchUserBookmarkLists()
  },
  computed: {
    sites: function() {
      let sites = [{ id: 'all', text: this.$t('select_all') }]
      const filtersConfig = this.$store.getters['config/filtersConfig']
      filtersConfig.filter_values.site_location.forEach(site => {
        sites.push({ site: site, text: this.$i18n.messages[this.$locale]['site_location'][site] })
      })
      return sites
    },
    languages: function() {
      return this.configFilterHierarchy.filter_values.language.map(language => ({
        id: language,
        text: this.$t('language.' + language),
      }))
    },
    autoCreateSite: function() {
      let sitesAutoComplete = this.sites.filter(i => {
        return i.text.toLowerCase().indexOf(this.temp.site.toLowerCase()) !== -1
      })
      return sitesAutoComplete
    },
    autoCreateLanguage: function() {
      let sitesAutoComplete = this.languages.filter(i => {
        return i.text.toLowerCase().indexOf(this.temp.language.toLowerCase()) !== -1
      })
      return sitesAutoComplete
    },
    autoCreateHistopadRating: function() {
      let autoComplete = this.rating.filter(i => {
        return i.text.toLowerCase().indexOf(this.temp.histopadRating.toLowerCase()) !== -1
      })
      return autoComplete
    },
    autoCreateVisitRating: function() {
      let autoComplete = this.rating.filter(i => {
        return i.text.toLowerCase().indexOf(this.temp.visitRating.toLowerCase()) !== -1
      })
      return autoComplete
    },
  },
  methods: {
    fetchUserBookmarkLists() {
      this.dataService.getUserBookmarkLists(this.getCurrentUser.id).then(response => {
        this.userBookmarkLists = response.result
      })
    },
    goToCommentStream() {
      let streamUrl = new URL(
        window.location.hostname === 'www.histoverydata.com' ||
        window.location.hostname === 'histoverydata.com'
          ? 'https://comments-stream-dot-histoeu.appspot.com'
          : 'http://localhost:8000',
      )
      window.open(streamUrl.href, 'tab')
    },
    displayConfigInTable(config) {
      let parsed = JSON.parse(config)

      let stringConfig = ''
      for (let property in parsed) {
        stringConfig += property + ': ' + parsed[property] + ' | '
      }

      return stringConfig.slice(0, stringConfig.length - 3)
    },
    async deleteProfile(id) {
      this.dataService.deleteStreamProfiles([id])
      this.userStreamProfiles = this.userStreamProfiles.filter(profile => profile.id !== id)
    },
    getUserStreamProfiles() {
      this.dataService.getUserStreamProfiles(this.getCurrentUser.id).then(response => {
        this.userStreamProfiles = response
      })
    },
    setFormCreate() {
      this.state = 'CREATE'

      this.form = { ...defaultFormValues }
      this.form.bookmarkId = this.userBookmarkLists[0].id
      this.setDefaultTagsInputs()
    },
    setFormUpdate(id) {
      this.state = 'UPDATE'

      this.dataService.getStreamProfile(id).then(response => {
        let display = JSON.parse(response.display_config)
        let query = JSON.parse(response.query_config)

        if (query && response.query_type === 'QUERY') {
          this.form.query.histopadRating = query.histopadRating.map(r =>
            this.rating.find(rr => rr.id === r),
          )
          this.form.query.visitRating = query.visitRating.map(r =>
            this.rating.find(rr => rr.id === r),
          )
          this.form.query.sites = query.sites.map(r => this.sites.find(rr => rr.site === r))
          this.form.query.languages = query.languages.map(r =>
            this.languages.find(rr => rr.id === r),
          )
          this.form.query.limit = query.limit
          this.form.query.scoreMax = query.scoreMax
          this.form.query.scoreMin = query.scoreMin
          this.form.queryType = 'QUERY'
          if (this.userBookmarkLists && this.userBookmarkLists.len > 0) {
            this.form.bookmarkId = this.userBookmarkLists[0].id
          }
        } else if (response.query_type === 'BOOKMARK') {
          this.form.query = { ...defaultFormValues }.query
          this.form.bookmarkId = response.bookmarklist_id
          this.form.queryType = 'BOOKMARK'

          this.setDefaultTagsInputs()
        }

        this.updateProfileId = id
        this.form.display = display
        this.form.id = response.id
        this.form.name = response.name
      })
    },
    setDefaultTagsInputs() {
      this.form.query.visitRating = [this.rating[3], this.rating[4]]
      this.form.query.histopadRating = [this.rating[3], this.rating[4]]

      // partner get all his accessible sites in default form
      if (this.getCurrentUser.userRole.name === 'partner') {
        this.form.query.sites = []
        this.getCurrentUser.sites.forEach(site => {
          this.form.query.sites.push({
            site: site.site,
            text: this.$i18n.messages[this.$locale]['site_location'][site.site],
          })
        })
      } else {
        this.form.query.sites = [{ id: 'all', text: this.$t('select_all') }]
      }
      this.form.query.languages = [
        this.languages.find(lang => lang.id == 'fr-FR'),
        this.languages.find(lang => lang.id == 'en-GB'),
      ]
    },
    async submitForm() {
      let form = document.getElementById('form-create')

      this.$log.debug('submitForm', form, form.checkValidity())

      if (!form.checkValidity()) {
        return
      }

      let display = JSON.stringify(this.form.display)
      let name = this.form.name
      let bookmarkListId = null
      let query = null

      if (this.form.queryType == 'QUERY') {
        // clone query
        query = JSON.parse(JSON.stringify(this.form.query))

        // remove vue-input-tags text
        let sites = []
        let langs = []
        let histoRating = []
        let visitRating = []
        for (let entry of query.sites) {
          sites.push(entry.site)
        }
        for (let entry of query.languages) {
          langs.push(entry.id)
        }
        for (let entry of query.histopadRating) {
          histoRating.push(entry.id)
        }
        for (let entry of query.visitRating) {
          visitRating.push(entry.id)
        }
        query.sites = sites
        query.languages = langs
        query.histopadRating = histoRating
        query.visitRating = visitRating

        query = JSON.stringify(query)
      } else {
        bookmarkListId = this.form.bookmarkId
      }

      if (bookmarkListId == null && query == null) {
        console.error('No bookmarkListId or query set.')
        return
      }

      this.$log.debug('CREATE OR UPDATE', this.state)

      if (this.state === 'CREATE') {
        this.dataService
          .createStreamProfile(
            name,
            display,
            query,
            this.getCurrentUser.id,
            bookmarkListId,
            this.form.queryType,
          )
          .then(response => {
            this.userStreamProfiles.push(response.data)
          })
      } else if (this.state === 'UPDATE') {
        this.dataService
          .updateStreamProfile(
            name,
            display,
            query,
            this.updateProfileId,
            bookmarkListId,
            this.form.queryType,
          )
          .then(() => {
            // set changes in vue state
            let updatedProfileIndex = this.userStreamProfiles.findIndex(
              profile => profile.id === this.updateProfileId,
            )
            this.userStreamProfiles[updatedProfileIndex] = {
              query_config: query,
              name: name,
              display_config: display,
              id: this.updateProfileId,
              bookmarklist_id: bookmarkListId,
              query_type: this.form.queryType,
              export_code: this.userStreamProfiles[updatedProfileIndex].export_code,
            }
            this.userStreamProfiles = JSON.parse(JSON.stringify(this.userStreamProfiles))
          })
      }

      // close modal
      document.getElementById('close-modal-create').click()
    },
    checkTagSite(event) {
      if (event.tag.id === 'all') {
        this.form.query.sites = []
      } else {
        this.form.query.sites = this.form.query.sites.filter(site => site.id !== 'all')
      }

      event.addTag()
    },

    setExportCode(xcode) {
      this.exports.exportCode = xcode
      this.exports.iFrameTag =
        '<iframe src="https://comments-stream-dot-histoeu.appspot.com/export/index.html?xcode=' +
        xcode +
        '"></iframe>'
    },
    exportDimensionsChecked() {
      if (!this.exports.areDimensionsEnabled) {
        this.exports.iFrameTag =
          '<iframe src="https://comments-stream-dot-histoeu.appspot.com/export/index.html?xcode=' +
          this.exports.exportCode +
          '" width="' +
          this.exports.width +
          '" height="' +
          this.exports.height +
          '"></iframe>'
      } else {
        this.exports.iFrameTag =
          '<iframe src="https://comments-stream-dot-histoeu.appspot.com/export/index.html?xcode=' +
          this.exports.exportCode +
          '"></iframe>'
      }
    },
    showToast: function(text) {
      this.$toasted.show(text, {
        theme: 'primary',
        position: 'bottom-center',
        duration: 2500,
      })
    },
  },
}
</script>

<style scoped>
.tags-input {
  width: 100% !important;
  max-width: none;
  border-radius: 10px;
  border: none;
  color: black;
}
.more-padding {
  padding: 20px 0;
}
form {
  padding: 30px;
}
form h2 {
  color: black;
}
.btn {
  margin: 10px;
}
</style>
